export const EXTESIONES_SOPORTADAS = [
  '.xls',
  '.xlsx'
]

export const CARPETA_GRUPO_INTERES = 'cargas-grupo-interes';